let AutosaveComponent = ['$timeout', ($timeout) => {
  return {
    restrict: 'A',
    require: ['^form'],
    link: ($scope, $element, $attrs, $ctrls) => {
      var $formCtrl = $ctrls[0];
      var savePromise = null;
      var expression = $attrs.autosave || 'true';
      $scope.$watch(() => {
        if ($formCtrl.$valid && $formCtrl.$dirty) {
          if (savePromise) {
            $timeout.cancel(savePromise);
          }
          savePromise = $timeout(() => {
            savePromise = null;
            // Still valid?
            if ($formCtrl.$valid) {
              if ($scope.$eval(expression) !== false) {
                $formCtrl.$setPristine();
              }
            }
          }, 500);
        }
      });
    }
  };
}];

export default AutosaveComponent;



// WEBPACK FOOTER //
// ./src/components/autosave/autosave.component.js